/** @format */

import React from 'react';
import Table from 'src/ui/library/Table';

class EntityWPVerticalTable extends React.Component {
  state = {
    showDelete: false,
    rowsSelected: [],
  };

  handleDelete = () => {};

  handleAdd = () => {};

  tableFooter = () => {
    return null;
  };

  onTableChange = (actionType, data) => {
    if (actionType === 'rowSelected') {
      const { selectedRows } = data.model;

      this.setState({
        showDelete: selectedRows.length ? true : false,
        rowsSelected: selectedRows,
      });
    }
  };

  render() {
    const {
      label,
      setUpdateModelFn,
      addNewRowFn,
      deleteRowsFn,
      elementActions,
      cancelRowsFn,
      setTableModelFn,
      setCancelSelectedRows,
      setUpdateColumnFn,
      ...otherProps
    } = this.props;
    return (
      <div className={'entity-table'}>
        <span className={'table-label'}>{label}</span>
        <Table
          footer={this.tableFooter}
          updateModel={setUpdateModelFn}
          setTableModel={setTableModelFn}
          updateColumn={setUpdateColumnFn}
          onTableChange={this.onTableChange}
          cancelSelectedRows={setCancelSelectedRows}
          {...otherProps}
          pagination={false}
          showVerticalMode={true}
          hardDisplay={false}
        />
      </div>
    );
  }
}

export default EntityWPVerticalTable;
